var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporateAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2942 16.2628C24.4561 16.2628 23.6524 16.5957 23.0597 17.1884C22.4671 17.781 22.1342 18.5847 22.1342 19.4228V20.7771H18.9742C17.4783 20.7771 16.2656 21.9898 16.2656 23.4857V37.0285C16.2656 38.5244 17.4783 39.7371 18.9742 39.7371H37.0313C38.5272 39.7371 39.7399 38.5244 39.7399 37.0285V23.4857C39.7399 21.9898 38.5272 20.7771 37.0313 20.7771H33.8713V19.4228C33.8713 18.5847 33.5384 17.781 32.9458 17.1884C32.3532 16.5957 31.5494 16.2628 30.7113 16.2628H25.2942ZM31.1628 20.7771V19.4228C31.1628 19.3031 31.1152 19.1883 31.0306 19.1036C30.9459 19.019 30.8311 18.9714 30.7113 18.9714H25.2942C25.1745 18.9714 25.0597 19.019 24.975 19.1036C24.8903 19.1883 24.8428 19.3031 24.8428 19.4228V20.7771H31.1628Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7573",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAccount);
export default __webpack_public_path__ + "static/media/corporate_account.598095daa04380e8592d586d8f7c8b2f.svg";
export { ForwardRef as ReactComponent };